const digitalEdge = 'https://p-gsg.digitaledge.cigna.com';
const staticPath = '/static/www-cigna-com';
const mycignaSpaDNS = 'https://my.cigna.com';
const i18nLoadPath = (lngs, _namespaces) => {
    if (lngs === 'en-us') {
        return `${staticPath}/json/{{- ns}}.json`;
    }
    return `${staticPath}/{{lng}}/json/{{- ns}}.json`;
};
export const config = {
    logLevel: 'error',
    i18n: {
        backend: { loadPath: i18nLoadPath },
        detection: {
            order: ['htmlTag'],
        },
    },
    paths: {
        json: `${staticPath}/json/`,
    },
    endpoints: {
        myCignaLogin: 'https://my.cigna.com/pkmslogin.form',
        dentalCampaign: 'https://cignadental.com/equotes/startInterview.action',
        igse: 'https://plans.cigna.com',
    },
    flags: {
        enableEloquaTestEmails: false,
        enableLegacyLogin: false,
    },
    myCigna: {
        mycignaSpaDNS: 'https://my.cigna.com',
        redirectUri: 'https://www.cigna.com/web/public/guest/callback',
        clientId: 'tHVhC9z0tpbg5hhJxCDE',
        issuer: 'https://p.login.my.cigna.com/oauth2/default',
        guest: `${mycignaSpaDNS}/web/public/guest`,
        consumer: `${mycignaSpaDNS}/web/public/guest/federate`,
        forgotID: `${mycignaSpaDNS}/web/public/consumer/forgotid`,
        forgotPassword: `${mycignaSpaDNS}/web/public/consumer/forgotpassword`,
        userInfo: 'https://p-digital.digitaledge.cigna.com/v1/profile',
        cookieDomain: '.cigna.com',
    },
    api: {
        gateways: {
            campaigns: `${digitalEdge}/webservices/common/v1/campaigns`,
            claimForm: `${digitalEdge}/webservices/www-cigna-com/v1/claims-form-submission`,
            relatedLinks: `${digitalEdge}/webservices/common/v1/related-links`,
            search: {
                uri: `${digitalEdge}/digital/cigna/search`,
                indexes: ['index-public-cigna-prod', 'index-public-cignahealthwise-prod'],
            },
            medicarePlanFinder: `${digitalEdge}/igse/connecturedrx2`,
            medicareConnectUsForm: 'https://apigateway0.cigna.com/v2/sforcethublead/lead/',
        },
    },
};
